<h2 mat-dialog-title>Anpassen der Steuern</h2>
<mat-dialog-content>Sollen die Netto- oder Bruttowerte angepasst werden?</mat-dialog-content>
<mat-dialog-actions align="end">
    <button app-button Color="cancel" [mat-dialog-close]="ChangeTaxOption.Cancel">Abbrechen</button>
    &nbsp;
    <button app-button Color="green" [mat-dialog-close]="ChangeTaxOption.AdjustGross">Bruttopreise anpassen
        <app-hint-icon hint="Es werden alle Bruttowerte angepasst: Nettopreis x MwSt."></app-hint-icon>
    </button>
    &nbsp;
    <button app-button Color="green" [mat-dialog-close]="ChangeTaxOption.AdjustNet">Nettopreise anpassen
        <app-hint-icon hint="Es werden alle Nettowerte angepasst: Bruttopreise / MwSt."></app-hint-icon>
    </button>
</mat-dialog-actions>
